import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import Navbar from "../../components/Common/Navbar/Navbar";
import IntroSectionMigrationCloud from '../../components/MigrationCloud/IntroSectionMigrationCloud/IntroSectionMigrationCloud';
import IntroSectionMigrationCloud2 from '../../components/MigrationCloud/IntroSectionMigrationCloud/IntroSectionMigrationCloud2';
import IntroSectionMigrationCloud3 from '../../components/MigrationCloud/IntroSectionMigrationCloud/IntroSectionMigrationCloud3';
import ContactSection from '../../components/HomePage/ContactSectionHome/ContactSectionHome';
import ExpertiseSectionMigrationCloud from '../../components/MigrationCloud/ExpertiseSectionMigrationCloud/ExpertiseSectionMigrationCloud';
import ServicesCardsMigrationCloud from '../../components/MigrationCloud/ServicesCardsMigrationCloud/ServicesCardsMigrationCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData1 from '../../components/Common/IntroSectionBottom/introSectionData1';
import './MigrationCloud.css';
import useSectionRefs from '../../hooks/useSectionRefs';
import BenefitsPrivateCloud from '../../components/MigrationCloud/ServicesSliderMigrationCloud/BenefitsMigrationCloud';
import ExpertiseSection from '../../components/CyberIncident/ExpertiseSectionCyberData/ExpertiseSectionCyberData';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelinePrivateCloud from '../../components/MigrationCloud/ServicesCardsMigrationCloud/TimelinePrivateCloud';
import BenefitsMigrationCloud from '../../components/MigrationCloud/ServicesSliderMigrationCloud/BenefitsMigrationCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzureMigration from '../../components/ui/pricing-section-azure-migration';

const MigrationCloud: React.FC = () => {
  const { t } = useTranslation();
  const sectionRefs = useSectionRefs();

  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
  const handleOpenContactModal = () => {
    setIsContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setIsContactModalOpen(false);
  };

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('migrationCloud.header.title', "Migration vers le cloud")}
            mobileTitle={t('migrationCloud.header.mobileTitle', "Migration<br />vers le cloud")}
            subtitle={t('migrationCloud.header.subtitle', "Optez pour une infrastructure performante et sécurisée")}
            mobileSubtitle={t('migrationCloud.header.mobileSubtitle', "Optez pour une infrastructure<br />performante et sécurisée")}
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionMigrationCloud />
      </section>

      <section id="commitment" className="section light commitment-section" ref={sectionRefs.commitment}>
        <IntroSectionMigrationCloud3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionMigrationCloud2 />
      </section>

      <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzureMigration />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
        <TimelinePrivateCloud />
        <GridPatternCard>
          <GridPatternCardBody>
            <div className="tw-h-[5em]">
            </div>
          </GridPatternCardBody>
        </GridPatternCard>
          </section>
          </div>
      </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
        <ContactLinkSection pageKey="migrationCloud" />
        <Footer />
      </section>
    </div>
    </div>
  );
};

export default MigrationCloud;
